import React, { FC, useEffect } from 'react';
import { isBrowser } from '../utils';

export interface OneTrustCookieListProps {}

export const OneTrustCookieList: FC<OneTrustCookieListProps> = () => {
  useEffect(() => {
    if (isBrowser) {
      window.OneTrust?.initializeCookiePolicyHtml();
    }
  }, []);
  return <div id="ot-sdk-cookie-policy" />;
};
